import React, { useEffect, useRef, useState } from 'react';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { useSelector } from 'react-redux';
import Loader from "../../../components/ui/Loader/Loader";
import tapIcon from "../../../services/TapIcon";
import Ax from "../../../components/hoc/Ax";
import HttpAPICall from '../../../services/HttpAPICall';
import { DisplayListPagination, DisplaySearchCriteria } from '../../../components/TapUi';
import { Helmet } from 'react-helmet';
import swal from "sweetalert";
import { toast } from 'react-toastify';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import InputAssetSearch from "../../includes/ui/InputAssetSearch";
import NewInputGroupSearch from "../../includes/ui/NewInputGroupSearch";
import moment from 'moment';
import Status from '../../../components/ui/Status';

const RefuelingList = ({ history }) => {
    const criteriaRef = useRef();
    const access_token = useSelector(state => state.auth.access_token);

    const refuelingUrl = BACKOFFICE_BASE_URL + '/refueling_draining';

    const [listingLoading, setListingLoading] = useState(false);
    const [refuelingListing, setRefuelingListing] = useState([]);
    const [listingMeta, setListingMeta] = useState(null);
    const [formSearchedElems, setFormSearchedElems] = useState([]);
    const [reportSubmitted, setReportSubmitted] = useState(false);
    const [criteriaHeight, setCriteriaHeight] = useState(0);

    const [filterForm, setFilterForm] = useState({
        show: true,
        search_group: null,
        search_assets: [],
    });

    const [appliedFilters, setAppliedFilters] = useState({
        search_master_id: "",
        search_asset_ids: [],
        search_group_data: [],
        search_asset_data: [],
    });

    useEffect(() => {
        if (!criteriaRef.current) {
            setCriteriaHeight(0);
            return;
        }

        const el = criteriaRef.current;

        const ro = new ResizeObserver(() => {
            setCriteriaHeight(el.offsetHeight || 0);
        });
        ro.observe(el);

        setCriteriaHeight(el.offsetHeight || 0);

        return () => ro.disconnect();
    }, [reportSubmitted]);
    const loadListingTblData = (page = 1, filters = appliedFilters) => {
        setListingLoading(true);

        const params = { page };

        if (filters.search_master_id) {
            params.search_master_id = filters.search_master_id;
        }
        if (filters.search_asset_ids && filters.search_asset_ids.length > 0) {
            params.search_asset_ids = filters.search_asset_ids;
        }

        HttpAPICall.withAthorization(
            'GET',
            refuelingUrl,
            access_token,
            params,
            {},
            (resp) => {
                const respData = resp.data;
                setRefuelingListing(respData.data || []);
                setListingMeta({
                    from: respData.from,
                    to: respData.to,
                    total: respData.total,
                    last_page: respData.last_page,
                    per_page: respData.per_page,
                    current_page: respData.current_page,
                });
            },
            (error) => {
                toast.error(error?.msg || 'Failed to load listing', {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        ).then(() => setListingLoading(false));
    };

    const reportFilterFormSubmit = (event = null) => {
        event && event.preventDefault();

        if (!filterForm.search_group) {
            toast.error("Please select a Group", { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        const searchedElems = [];
        searchedElems.push(`Group : <b>${filterForm.search_group.label}</b>`);

        if (filterForm.search_assets && filterForm.search_assets.length > 0) {
            const assetLabels = filterForm.search_assets
                .map(a => a.label || a.value)
                .join(', ');
            searchedElems.push(`Asset : <b>${assetLabels}</b>`);
        }

        const newApplied = {
            search_master_id: filterForm.search_group.value,
            search_asset_ids: filterForm.search_assets
                .map(a => a.value ?? a.asset_id ?? a.id)
                .filter(Boolean),
            search_group_data: [filterForm.search_group],
            search_asset_data: filterForm.search_assets,
        };

        setAppliedFilters(newApplied);
        setFormSearchedElems(searchedElems);
        setReportSubmitted(true);
        setFilterForm(prev => ({ ...prev, show: false }));
        loadListingTblData(1, newApplied);
    };

    const toggleFilterForm = (show) => {
        setFilterForm(prev => ({ ...prev, show }));
        if (document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    };

    const clearFilter = () => {
        setFormSearchedElems([]);
        setReportSubmitted(false);
        setFilterForm({ show: true, search_group: null, search_assets: [] });
        setAppliedFilters({
            search_master_id: "",
            search_asset_ids: [],
            search_group_data: [],
            search_asset_data: [],
        });
        setRefuelingListing([]);
        setListingMeta(null);
        setCriteriaHeight(0);
    };

    const changeStatusHandler = (item) => {
        const statusLabel =
            item?.status?.status_text === "Unverified" ? 'Verified' : 'Unverified';

        swal({
            title: "Change Status",
            text: `Are you sure you want to change status to ${statusLabel}?`,
            icon: "warning",
            buttons: ["No", "Yes"],
        }).then((willChangeStatus) => {
            if (willChangeStatus) {
                const frmData = {
                    id: item.id,
                    status: item?.status?.status,
                    search_master_id: appliedFilters.search_master_id,
                };

                HttpAPICall.withAthorization(
                    'PUT',
                    BACKOFFICE_BASE_URL + '/refueling_draining_status_change',
                    access_token,
                    {},
                    frmData,
                    (response) => {
                        const resp = response.data;
                        toast.success(resp.msg || 'Status updated successfully!', {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        loadListingTblData(listingMeta?.current_page || 1, appliedFilters);
                    },
                    (error) => {
                        toast.error(error?.msg || 'Failed to update status', {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    }
                );
            }
        });
    };

    const formatDateTime = (value) =>
        value ? moment(value, "YYYY-MM-DD HH:mm:ss").format("DD-MMM-YYYY h:mm A") : "-";

    const pageTitleBarJsx = () => (
        <div className="page_title row m0">
            <div className="col-sm-12 px-2">
                <div className="d-flex align-items-center justify-content-between">
                    <h3>
                        <tapIcon.FontAwesomeIcon icon={tapIcon.faGasPump} /> Refueling &amp; Drainage List
                    </h3>
                    <div className="d-flex align-items-center">
                        {reportSubmitted && (
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => toggleFilterForm(!filterForm.show)}
                            >
                                Change Filter
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );

    const reportFilterFormJsx = () => {
        const isGroupSelected = !!(filterForm.search_group && filterForm.search_group.value);

        return (
            <form onSubmit={reportFilterFormSubmit} className="py-3">
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end require">Group</label>
                    <div className="col-sm-6">
                        <NewInputGroupSearch
                            placeholder="Search Group"
                            changeEvent={(selectedOption) => {
                                setFilterForm(prev => ({
                                    ...prev,
                                    search_group: selectedOption || null,
                                    search_assets: [],
                                }));
                            }}
                            value={filterForm.search_group}
                            isClearable={true}
                        />
                    </div>
                </div>

                <div className="row mb-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Asset</label>
                    <div className="col-sm-6">
                        <InputAssetSearch
                            placeholder={
                                isGroupSelected
                                    ? "Select Assets"
                                    : "Please select a group first"
                            }
                            changeEvent={(selectedOptions) => {
                                const options = Array.isArray(selectedOptions)
                                    ? selectedOptions
                                    : selectedOptions
                                        ? [selectedOptions]
                                        : [];
                                setFilterForm(prev => ({ ...prev, search_assets: options }));
                            }}
                            isClearable={true}
                            isMulti={true}
                            master_id={isGroupSelected ? filterForm.search_group.value : ""}
                            value={filterForm.search_assets}
                            isDisabled={!isGroupSelected}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="pb-3 col-9 text-end">
                        <button
                            type="submit"
                            disabled={listingLoading || !filterForm.search_group}
                            className="btn btn-primary px-4"
                        >
                            Show
                        </button>
                    </div>
                </div>
            </form>
        );
    };
    const refuelingListingJsx = () => {
        return (
            <Ax>
                <table className="table table-bordered bg-white table-sm">
                    <thead
                        className="table-secondary"
                        style={{
                            top: `${criteriaHeight}px`,
                            position: 'sticky',
                        }}
                    >
                        <tr className="text-center">
                            <th scope="col" style={{ width: "3%" }}>S.No</th>
                            <th scope="col" style={{ width: "8%" }}>Group Name</th>
                            <th scope="col" style={{ width: "10%" }}>Asset</th>
                            <th scope="col" style={{ width: "7%" }}>IMEI</th>
                            <th scope="col" style={{ width: "7%" }}>Site</th>
                            <th scope="col" style={{ width: "7%" }}>Refueling Volume</th>
                            <th scope="col" style={{ width: "8%" }}>Refueling Time</th>
                            <th scope="col" style={{ width: "7%" }}>Draining Volume</th>
                            <th scope="col" style={{ width: "8%" }}>Draining Time</th>
                            <th scope="col" style={{ width: "5%" }}>Status</th>
                            <th scope="col" style={{ width: "7%" }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listingLoading ? (
                            <tr>
                                <td colSpan="11"><Loader /></td>
                            </tr>
                        ) : refuelingListing && refuelingListing.length > 0 ? (
                            refuelingListing.map((item, index) => {
                                const assetData = item?.asset_data || {};
                                const groupName = item?.group || "-";
                                const assetName = assetData?.name || "-";
                                const assetCode = assetData?.asset_code || "-";
                                const siteName = assetData?.site || "-";
                                const IemiNo = item?.imei || "-";

                                return (
                                    <tr key={item.id || index}>
                                        <td className="text-center">
                                            {listingMeta ? listingMeta.from + index : index + 1}
                                        </td>
                                        <td>{groupName}</td>
                                        <td>
                                            {assetName}
                                            {assetCode !== "-" && <small> ({assetCode})</small>}
                                        </td>
                                        <td>{IemiNo}</td>
                                        <td>{siteName}</td>
                                        <td className="text-end">
                                            {parseFloat(item.starting_volumn || 0).toFixed(2)}
                                        </td>
                                        <td>{formatDateTime(item.starting_time)}</td>
                                        <td className="text-end">
                                            {parseFloat(item.end_volumn || 0).toFixed(2)}
                                        </td>
                                        <td>{formatDateTime(item.end_time)}</td>
                                        <td className="text-center">
                                            <span
                                                style={{ cursor: 'pointer' }}
                                                title="Click to change status"
                                                onClick={() => changeStatusHandler(item)}
                                            >
                                                <Status color={item?.status?.status_color_code}>
                                                    {item?.status?.status_text}
                                                </Status>
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            <tapIcon.imageIcon
                                                icon={tapIcon.ListActionIcon}
                                                alt="action-icon"
                                                className="img-fluid px-3"
                                                data-bs-toggle="dropdown"
                                                href="#"
                                                role="button"
                                                aria-expanded="false"
                                            />
                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                <li>
                                                    <a
                                                        className="dropdown-item"
                                                        role="button"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            changeStatusHandler(item);
                                                        }}
                                                    >
                                                        {item?.status?.status_text === "Unverified"
                                                            ? 'Verified'
                                                            : 'UnVerified'}
                                                    </a>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="11" className="text-center">No Records</td>
                            </tr>
                        )}
                    </tbody>
                </table>

                <DisplayListPagination
                    meta={listingMeta}
                    onPageChange={(e) => loadListingTblData(e.selected + 1, appliedFilters)}
                />
            </Ax>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Refueling / Draining List</title></Helmet>
            {pageTitleBarJsx()}
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div id="pageTbl" className="pageTbl col-sm-12 pb-3">
                        <div
                            className="bg-white"
                            style={{ display: filterForm.show ? 'block' : 'none' }}
                        >
                            {reportFilterFormJsx()}
                        </div>

                        {reportSubmitted && (
                            <>
                                {formSearchedElems.length > 0 && (
                                    <div
                                        ref={criteriaRef}
                                        style={{
                                            position: 'sticky',
                                            top: 0,
                                            background: 'white',
                                        }}
                                    >
                                        <DisplaySearchCriteria
                                            searchedElems={formSearchedElems}
                                            onClearFilter={clearFilter}
                                        />
                                    </div>
                                )}
                                <div className="bg-white pb-4">
                                    {refuelingListingJsx()}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
};

export default RefuelingList;